import type { FC } from "react";
import { useState, useRef, useEffect } from "react";

import { PlainTooltip } from "@similarweb/ui-components";

import { StyledTextOverflow } from "app/pages/sales-intelligence/common-components/OverflowTooltipWithObserver/styles";

type Props = {
    text: string;
};

export const OverflowTooltipWithObserver: FC<Props> = ({ text }) => {
    const [isOverflowing, setIsOverflowing] = useState(false);
    const textRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (!textRef.current) {
            return;
        }
        const isTextOverflowing = Boolean(textRef.current.scrollWidth > textRef.current.clientWidth);
        setIsOverflowing(isTextOverflowing);

        const resizeObserver = new ResizeObserver(() => {
            if (!textRef.current) {
                return;
            }

            setIsOverflowing(textRef.current.scrollWidth > textRef.current.clientWidth);
        });

        resizeObserver.observe(textRef.current);

        return () => {
            resizeObserver.disconnect();
        };
    }, []);

    return isOverflowing ? (
        <PlainTooltip
            tooltipContent={text}
            placement="top-center"
        >
            <StyledTextOverflow>{text}</StyledTextOverflow>
        </PlainTooltip>
    ) : (
        <StyledTextOverflow ref={textRef}>{text}</StyledTextOverflow>
    );
};
